import { render, staticRenderFns } from "./user-agreement.vue?vue&type=template&id=052216e5&"
import script from "./user-agreement.vue?vue&type=script&lang=js&"
export * from "./user-agreement.vue?vue&type=script&lang=js&"
import style0 from "./user-agreement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports